import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../component-base';
import { OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppToolbarOptionsComponent } from '@ifaa-components/ui-components';
import { AppComponentWrapperComponent } from 'src/app/modules/shared/components/app-component-wrapper/app-component-wrapper.component';
import { PensionChangeScheduleRequestsComponent } from 'src/app/modules/shared/components/pension-change-schedule-requests/pension-change-schedule-requests.component';
import { AnimateCssDirective } from 'src/app/modules/shared/directives/animatecss.directive';
import { TextTransformPipe } from 'src/app/modules/shared/pipes/textTransform';

@Component({
  selector: 'app-pension-change-schedule-requests-view',
  templateUrl: './pension-change-schedule-requests-view.component.html',
  styleUrls: ['./pension-change-schedule-requests-view.component.scss'],
  host: {
    class: 'w-100',
  },
  imports: [
    AppComponentWrapperComponent,
    AnimateCssDirective,
    AppToolbarOptionsComponent,
    TextTransformPipe,
    PensionChangeScheduleRequestsComponent,
  ],
})
export class PensionChangeScheduleRequestsViewComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  constructor(public store: Store<AppState>, private router: Router) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }
}
